<template>
    <div class="scrollToTop" v-if="isVisible">
        <div class="arrow">
            <a @click.prevent="scrollToSection('top')" class="arrow-pos">
                <Icon icon="material-symbols:keyboard-double-arrow-up-rounded" width="50" height="50" style="color: var(--bgPink)"/>
            </a>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { Icon } from '@iconify/vue';

const isVisible = ref(false);

const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  }
};

const handleScroll = () => {
  isVisible.value = window.scrollY > 0;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

</script>
<style lang="scss" scoped>
@import '../assets/main.css';

.scrollToTop {
    position: fixed;
    bottom: 80px;
    right: 20px;
    border: 1px solid var(--bgPink);
    border-radius: 5px;
    width: 60px;
    height: 60px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2200;
  
    .arrow {
        position: absolute;
        animation: bounce 1s infinite ease-in-out;
        top: 10%;
        
    }
  }

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @media (max-width: 1025px) {
    .scrollToTop {
        display: none;
    }
  }
</style>